import { Option, none, isNone, some } from 'fp-ts/lib/Option';
import { WidgetType } from 'domain/entity/widget';

export class PresetFieldDependency {
    constructor(readonly key: string, readonly value: string) {}
}

export default interface ReadPresetFieldCriteria {
    field: string;
    preset: string;
    dependencies: PresetFieldDependency[];
    widgetType: WidgetType;
    pageSize: number;
}

class ReadPresetFieldCriteriaImpl implements ReadPresetFieldCriteria {
    constructor(
        readonly field: string,
        readonly preset: string,
        readonly dependencies: PresetFieldDependency[],
        readonly widgetType: WidgetType,
        readonly pageSize: number
    ) {}
}

export class ReadPresetFieldCriteriaBuilder {
    private field: Option<string> = none;

    private preset: Option<string> = none;

    private dependencies: PresetFieldDependency[] = [];

    private widgetType: Option<WidgetType> = none;

    private pageSize: Option<number> = none;

    static create = (): ReadPresetFieldCriteriaBuilder => new ReadPresetFieldCriteriaBuilder();

    withField = (field: string): ReadPresetFieldCriteriaBuilder => {
        this.field = some(field);
        return this;
    };

    withPreset = (preset: string): ReadPresetFieldCriteriaBuilder => {
        this.preset = some(preset);
        return this;
    };

    withDependencies = (dependencies: PresetFieldDependency[]): ReadPresetFieldCriteriaBuilder => {
        this.dependencies = dependencies;
        return this;
    };

    withWidgetType = (widgetType: WidgetType | undefined): ReadPresetFieldCriteriaBuilder => {
        if (widgetType !== undefined) {
            this.widgetType = some(widgetType);
            return this;
        }
        this.widgetType = none;
        return this;
    };

    withPageSize = (pageSize: number): ReadPresetFieldCriteriaBuilder => {
        this.pageSize = some(pageSize);
        return this;
    };

    build = (): ReadPresetFieldCriteria => {
        if (isNone(this.field) || isNone(this.preset) || isNone(this.widgetType) || isNone(this.pageSize)) {
            throw new ReferenceError('Undefined prop');
        }
        return new ReadPresetFieldCriteriaImpl(
            this.field.value,
            this.preset.value,
            this.dependencies,
            this.widgetType.value,
            this.pageSize.value
        );
    };
}
